import * as React from 'react';
import { DeliveryIndicator } from '@grandvisionhq/shipping';
import { useCart } from '../../../context/Cart/context.js';
import '@swc/helpers';
import '@grandvisionhq/common';
import '@grandvisionhq/graphql';
import '@grandvisionhq/state';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import { useCartSettings } from '../../../context/CartSettings/context.js';
import '../../../models/add-to-cart/add-to-cart.js';
import '../../../models/cart/cart.js';
import '../../../models/checkoutState/checkoutState.js';
import '../../../utils/cart-count-var.js';
import '../../../utils/cart-id-var.js';
import '@grandvisionhq/commercetools';
import '../../../utils/get-unrecoverable-validation-errors.js';
import '../../../models/line-item/prescription-glasses.js';
import '../../../utils/get-failure-error-codes.js';
import '../../../utils/get-validation-errors-by-line-item.js';
import '@grandvisionhq/lib-visuals';
import '../../../operations/fragments/cart-details.js';
import '../../../operations/fragments/cart-validation-errors.js';
import '../../../operations/fragments/recover-inactive-cart-failure.js';
import '../../../operations/fragments/recover-inactive-cart-result.js';
import '../../../operations/mutations/add-cart-line-items.js';
import '../../../operations/mutations/add-cart-voucher-codes.js';
import '../../../operations/mutations/create-cart.js';
import '../../../operations/mutations/create-cart-from-instant-checkout-link.js';
import '../../../operations/mutations/create-cart-from-order.js';
import '../../../operations/mutations/duplicate-cart-line-items.js';
import '../../../operations/mutations/remove-cart-voucher-codes.js';
import '../../../operations/mutations/remove-cart-line-items.js';
import '../../../operations/mutations/update-cart-line-items.js';
import '../../../operations/mutations/recover-inactive-cart.js';
import '../../../operations/queries/get-cart.js';
import '../../../operations/queries/get-total-line-items.js';
import '../../../operations/queries/get-cart-estimated-delivery.js';

const DeliveryIndicatorContainer = ({ lineItemId  })=>{
    const settings = useCartSettings();
    const { cart  } = useCart();
    const lineItem1 = cart === null || cart === void 0 ? void 0 : cart.lineItems.filter((lineItem)=>lineItem.id === lineItemId
    )[0];
    if (!lineItem1) {
        return null;
    }
    const deliveryResolver = settings.deliveryResolverFactory && settings.deliveryResolverFactory([
        lineItem1
    ]);
    return /*#__PURE__*/ React.createElement(DeliveryIndicator, {
        view: "short",
        availability: lineItem1.availability ? [
            lineItem1.availability
        ] : [],
        deliveryResolver: deliveryResolver
    });
};

export { DeliveryIndicatorContainer };
//# sourceMappingURL=DeliveryIndicatorContainer.js.map
